import Image from '../../../../atoms/Image';
import Text from '../../../../atoms/Text';
import web from '../../../../assets/images/web_grey.svg';
import linkedin from '../../../../assets/images/linkedin_grey.svg';
import twitter from '../../../../assets/images/twitter_grey.svg';
import messenger from '../../../../assets/images/messenger_grey.svg';

const SidebarFooter = () => {
  return (
    <div className='global_sidebar_mobile__footer'>
      <div className='global_sidebar_mobile__footer__social'>
        <a
          href='https://www.facebook.com/kattanatrade'
          target='_blank'
          rel='noreferrer'
          className='global_sidebar_mobile__footer__social__item'
        >
          <Image size='m' src={messenger} />
        </a>
        <a
          href='https://twitter.com/kattanatrade'
          target='_blank'
          rel='noreferrer'
          className='global_sidebar_mobile__footer__social__item'
        >
          <Image size='m' src={twitter} />
        </a>
        <a
          href='https://www.linkedin.com/company/kattana'
          target='_blank'
          rel='noreferrer'
          className='global_sidebar_mobile__footer__social__item'
        >
          <Image size='m' src={linkedin} />
        </a>
        <a
          href='https://kattana.io'
          target='_blank'
          rel='noreferrer'
          className='global_sidebar_mobile__footer__social__item'
        >
          <Image size='m' src={web} />
        </a>
      </div>
      <div className='global_sidebar_mobile__footer__info'>
        <a
          href='https://kattana.io/terms_of_service'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: 'none' }}
        >
          <Text size={12} className='text--weight-500 text--grey-600'>
            Terms of Use
          </Text>
        </a>
        <div className='global_sidebar_mobile__footer__info__separator' />
        <a
          href='https://kattana.io/privacy_policy'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: 'none' }}
        >
          <Text size={12} className='text--weight-500 text--grey-600'>
            Privacy Policy
          </Text>
        </a>
        <div className='global_sidebar_mobile__footer__info__separator' />
        <a
          href='https://kattana.io/vision'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: 'none' }}
        >
          <Text size={12} className='text--weight-500 text--grey-600'>
            About Us
          </Text>
        </a>
      </div>
    </div>
  );
};

export default SidebarFooter;
